import { Injectable } from '@angular/core';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { Observable } from 'rxjs';
import { DocumentDetails } from './document-details.model';
import { NotificationService } from 'projects/bis-shared/src/lib/notification/notification.service';
import { Moment } from 'moment-timezone';
import { DocumentSharedService } from 'projects/bis-shared/src/lib/document-shared/document-shared.service';
import { PrintDocumentService } from 'projects/bis-shared/src/lib/document-shared/print-document.service';
import { NotificationConstants } from 'projects/bis-shared/src/lib/utility/notification-constants';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(
    private notificationService: NotificationService,
    private externalApiUrls: ExternalApiUrls,
    private docService: DocumentSharedService,
    private printService: PrintDocumentService,
  ) {
    notificationService.setNotifier(
      NotificationConstants.DocumentDownload,
      docService.downloadCallback(this.externalApiUrls.document.download),
    );
    notificationService.setNotifier(
      NotificationConstants.DocumentDownloadWithChildren,
      docService.downloadRelatedCallback(this.externalApiUrls.document.downloadRelated),
    );
    notificationService.setNotifier(
      NotificationConstants.Print,
      this.printService.loadAndPrintCallback(this.externalApiUrls.document.download),
    );
  }

  getDocumentDetails(id: number): Observable<DocumentDetails> {
    return this.docService.getDocumentDetails<DocumentDetails>(
      this.externalApiUrls.document.getDetails,
      id,
    );
  }

  downloadCall = (fileUri: string, fileName: string) =>
    this.docService.downloadCall(fileUri, fileName);

  async downloadRelated(documentId: string | number, downloadDate?: Moment): Promise<void> {
    await this.notificationService.ensureConnected();
    this.docService.downloadRelated(this.externalApiUrls.document.downloadRelated)(
      documentId,
      downloadDate,
    );
  }

  download = async (documentId: string | number, downloadDate?: Moment): Promise<void> => {
    await this.notificationService.ensureConnected();
    this.docService.download(this.externalApiUrls.document.download)(documentId, downloadDate);
  };

  print = async (documentId: number): Promise<void> => {
    await this.notificationService.ensureConnected();
    this.printService.loadAndPrint(this.externalApiUrls.document.download)(documentId);
  };
}
